import { supabase } from "@/integrations/supabase/client";

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
let sessionTimer: NodeJS.Timeout;

export const setupSessionTimeout = (onTimeout: () => void) => {
  clearTimeout(sessionTimer);
  sessionTimer = setTimeout(onTimeout, SESSION_TIMEOUT);

  // Reset timer on user activity
  const resetTimer = () => {
    clearTimeout(sessionTimer);
    sessionTimer = setTimeout(onTimeout, SESSION_TIMEOUT);
  };

  window.addEventListener("mousemove", resetTimer);
  window.addEventListener("keypress", resetTimer);
  window.addEventListener("click", resetTimer);

  return () => {
    window.removeEventListener("mousemove", resetTimer);
    window.removeEventListener("keypress", resetTimer);
    window.removeEventListener("click", resetTimer);
    clearTimeout(sessionTimer);
  };
};

export const logError = (error: unknown, context: string) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  console.error(`[${context}] ${errorMessage}`, {
    timestamp: new Date().toISOString(),
    context,
    error,
  });
};